import * as React from 'react'
import styles from './style.module.css';
import {isEmpty} from "lodash";
import service_point_color from '../../../../../../../static/IconProvider/service_point_color.svg';
import IconProvider from '../../../../../../../design-system/lib/IconProvider';
import Typography from '../../../../../../../design-system/lib/Typography';




function ServicePoint_addressItem({data , onclick}) {

  let stylee ={
    maxWidth: '324px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
  return (
    <div className={styles.CustomerListItemContainer} onClick={onclick && onclick}>
        <IconProvider Icon={service_point_color} size='16' />

        <div className={styles.namePhoneContainer}>
            <Typography weight='Body_Tiny_Medium' text={data.name}  style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',...stylee
        }}/>
            <Typography weight='Body_Tiny_Regular' text={ data.address} style={stylee} />

        </div>
    </div>
  )
}

export default ServicePoint_addressItem